export const getServiceTemplateMapStatus = serviceTemplate => serviceTemplate.integratedId ? 'mapped' : 'notMapped';